import { Box } from '@mantine/core'

const BAR_HEIGHT = 2

interface WinChanceBarProps {
  color?: string
  /** 0–100（contract.chance 已 ×100）。 */
  chancePct?: number | null
  /** true → 整条填满（胜率无关的强调条）。 */
  solid?: boolean
}

/**
 * Port of cdc-web `Compact/_shared/WinChanceBar.tsx`（1:1）。
 * 名字下方的 2px 比例条：宽度 = clamp(chancePct, 0, 100)%。
 */
export function WinChanceBar({ color, chancePct, solid = false }: Readonly<WinChanceBarProps>) {
  const shouldRender = !!color && (solid || (chancePct != null && chancePct > 0))
  if (!shouldRender) return null

  const clamped = Math.min(100, Math.max(0, chancePct ?? 0))
  const width = solid ? '100%' : `${clamped}%`

  return (
    <Box w="100%" style={{ height: BAR_HEIGHT, borderRadius: 8, overflow: 'hidden' }}>
      <Box
        data-testid="win-chance-fill"
        style={{ width, height: BAR_HEIGHT, borderRadius: 8, backgroundColor: color }}
      />
    </Box>
  )
}
